module.exports = __webpack_public_path__ + "img/shaomai-bg.be3beb9b.jpg";